<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">予算・計画・実績表</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="block-column">
          <div>
            <h2>予算</h2>
            <table [style.width.px]="260" class="kymw1300-table">
              <tr>
                <th [style.width.px]="130">金額（千円）</th>
                <th [style.width.px]="130">粗利（千円）</th>
              </tr>
              <tr>
                <td>{{kymw1307Model.budgetAmount | comma}}</td>
                <td>{{kymw1307Model.budgetGP | comma}}</td>
              </tr>
            </table>
          </div>

          <div>
            <h2>計画</h2>
            <div class="block-row">
              <table [style.width.px]="250" class="kymw1300-table">
                <tr>
                  <th [style.width.px]="62">　</th>
                  <th [style.width.px]="120">総額（千円）</th>
                  <th [style.width.px]="120">予算比</th>
                </tr>
                <tr>
                  <td class="title">金額</td>
                  <td>{{kymw1307Model.planAmount | comma}}</td>
                  <td>{{kymw1307Model.planAmountRatio | number:'1.1-1'  | comma | suffix:'%'}}</td>
                </tr>
                <tr>
                  <td class="title">粗利</td>
                  <td>{{kymw1307Model.planGP | comma}}</td>
                  <td>{{kymw1307Model.planGPRatio | number:'1.1-1'  | comma | suffix:'%'}}</td>
                </tr>
              </table>

              <table [style.width.px]="330" class="kymw1300-table">
                <tr>
                  <th [style.width.px]="62">　</th>
                  <th [style.width.px]="120">ＧＰ（千円）</th>
                  <th [style.width.px]="120">ＧＰＲ</th>
                  <th [style.width.px]="120">点単価</th>
                </tr>
                <tr>
                  <td class="title">今年</td>
                  <td>{{kymw1307Model.planThisGP | comma}}</td>
                  <td>{{kymw1307Model.planThisGPR | number:'1.1-1'  | comma | suffix:'%'}}</td>
                  <td>{{kymw1307Model.planThisAveragePrice | number:'1.1-1' | comma}}</td>
                </tr>
                <tr>
                  <td class="title">前年比</td>
                  <td>{{kymw1307Model.planRatioGP | number:'1.1-1'  | comma | suffix:'%'}}</td>
                  <td>{{kymw1307Model.planRatioGPR | number:'1.1-1'  | comma | suffix:'%'}}</td>
                  <td>{{kymw1307Model.planRatioAveragePrice | number:'1.1-1'  | comma | suffix:'%'}}</td>
                </tr>
              </table>
            </div>
          </div>

          <div>
            <h2>実績</h2>
            <div class="block-row">
              <table [style.width.px]="250" class="kymw1300-table">
                <tr>
                  <th [style.width.px]="62">　</th>
                  <th [style.width.px]="120">総額（千円）</th>
                  <th [style.width.px]="120">予算比</th>
                </tr>
                <tr>
                  <td class="title">金額</td>
                  <td>{{kymw1307Model.resultsAmount | comma}}</td>
                  <td>{{kymw1307Model.resultsAmountRatio | number:'1.1-1'  | comma | suffix:'%'}}</td>
                </tr>
                <tr>
                  <td class="title">粗利</td>
                  <td>{{kymw1307Model.resultsGP | comma}}</td>
                  <td>{{kymw1307Model.resultsGPRatio | number:'1.1-1'  | comma | suffix:'%'}}</td>
                </tr>
              </table>

              <table [style.width.px]="330" class="kymw1300-table">
                <tr>
                  <th [style.width.px]="62">　</th>
                  <th [style.width.px]="120">ＧＰ（千円）</th>
                  <th [style.width.px]="120">ＧＰＲ</th>
                  <th [style.width.px]="120">点単価</th>
                </tr>
                <tr>
                  <td class="title">今年</td>
                  <td>{{kymw1307Model.resultsThisGP | comma}}</td>
                  <td>{{kymw1307Model.resultsThisGPR | number:'1.1-1'  | comma | suffix:'%'}}</td>
                  <td>{{kymw1307Model.resultsThisAveragePrice | number:'1.1-1' | comma}}</td>
                </tr>
                <tr>
                  <td class="title">前年比</td>
                  <td>{{kymw1307Model.resultsRatioGP | number:'1.1-1'  | comma | suffix:'%'}}</td>
                  <td>{{kymw1307Model.resultsRatioGPR | number:'1.1-1'  | comma | suffix:'%'}}</td>
                  <td>{{kymw1307Model.resultsRatioAveragePrice | number:'1.1-1'  | comma | suffix:'%'}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="window-title-close">
        <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
        <button id="btn_Close" [tabindex]="0" (click)="onClickWindowClose()" forcedEnabledMode="true"></button>
      </div>
      <div cdkDragHandle class="drag-subwindow-bottom-area"></div>
    </td>
  </tr>
</table>